import React from "react";

export const LoadingShimmer = () => (
	<div className="P(20px)">
		<div className="shimmer H(100px) Mb(20px)" />
		<div className="shimmer H(100px) Mb(20px)" />
	</div>
);
